/**
 * Enforces a maximum number of times a function can be called over time.
 * As in 'execute this function at most once every 100 milliseconds.
 *
 * @param {Function} originFn Function that will be throttled.
 * @param {Integer} wait Wait time for the function in ms
 */
const throttle = (originFn, wait) => {
  let isThrottled = false;
  let originalArgs = null;
  let context = null;

  const wrapper = (...args) => {
    if (isThrottled) {
      originalArgs = args;
      context = this;
      return null;
    }
    isThrottled = true;
    originFn.apply(this, args);

    return setTimeout(() => {
      isThrottled = false;
      if (originalArgs) {
        wrapper.apply(context, originalArgs);
        originalArgs = null;
        context = null;
      }
    }, wait);
  };

  return wrapper;
};

export default throttle;
